import InputAIDisclaimer from './inputAIDisclaimer';
export default InputAIDisclaimer;